{
  "type": "object",
  "properties": {
    "IntendedFor": { "type": "string", "minLength": 1 },
    "iEEGCoordinateSystem": {
      "anyOf": [
        { "$ref": "common_definitions.json#/definitions/iEEGCoordSys" },
        {
          "$ref": "common_definitions.json#/definitions/StandardTemplateCoordSys"
        },
        {
          "$ref": "common_definitions.json#/definitions/StandardTemplateDeprecatedCoordSys"
        }
      ]
    },
    "iEEGCoordinateUnits": {
      "type": "string",
      "enum": ["m", "mm", "cm", "pixels", "n/a"]
    },
    "iEEGCoordinateSystemDescription": { "type": "string", "minLength": 1 },
    "iEEGCoordinateProcessingDescription": { "type": "string", "minLength": 1 },
    "iEEGCoordinateProcessingReference": { "type": "string", "minLength": 1 }
  },
  "required": ["iEEGCoordinateSystem", "iEEGCoordinateUnits"],
  "additionalProperties": false,
  "allOf": [
    {
      "$ref": "#/dependency-definitions/if-iEEGCoordinateSystem-is-Other-then-Description-is-required"
    },
    {
      "$ref": "#/dependency-definitions/if-iEEGCoordinateSystem-is-Pixels-then-iEEGCoordinateUnits-must-be-pixels"
    }
  ],
  "dependency-definitions": {
    "if-iEEGCoordinateSystem-is-Other-then-Description-is-required": {
      "if": {
        "type": "object",
        "properties": {
          "iEEGCoordinateSystem": { "const": "Other" }
        },
        "required": ["iEEGCoordinateSystem"]
      },
      "then": { "required": ["iEEGCoordinateSystemDescription"] }
    },
    "if-iEEGCoordinateSystem-is-Pixels-then-iEEGCoordinateUnits-must-be-pixels": {
      "if": {
        "type": "object",
        "properties": {
          "iEEGCoordinateSystem": { "const": "Pixels" }
        },
        "required": ["iEEGCoordinateSystem"]
      },
      "then": {
        "type": "object",
        "properties": {
          "iEEGCoordinateUnits": { "type": "string", "enum": ["pixels"] }
        },
        "required": ["iEEGCoordinateUnits"]
      }
    }
  }
}
